import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=d99c3196&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d99c3196')) {
      api.createRecord('d99c3196', component.options)
    } else {
      api.reload('d99c3196', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=d99c3196&", function () {
      api.rerender('d99c3196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JYZa1XPWxKJL/JS/imageCarousel.vue"
export default component.exports